import axios from 'axios';
import API, { APIWithoutToken } from './dbServices/api';
import { getAPICachingTime, returnAPICachingHeader } from '../helpers/helpers';
import { cachingHigh, cachingVeryHigh } from '../data/webPageData';

import StoriesSvc from './StoriesSvc';
import { RetryAPICall } from '../helpers/apiHelpers';

const caches = {};

export default class HPService {
  static async getHomePageStories(id, period, params = {}, callCurationActions) {
    this.storySource = axios.CancelToken.source();

    try {
      const { stories, cancelled } = await StoriesSvc.getStoriesData({
        asset_classes: id,
        time_filter: period,
        with_sentiments: true,
        ...params,
      },
      { cancelToken: this.storySource.token, callCurationActions });

      if (cancelled) return [];

      return stories;
    } catch (e) {
      if (axios.isCancel(e)) {
        console.log('Request canceled', e.message);
      } else {
        console.error(e.message);
      }
      return [];
    }
  }

  static cancelStoriesRequest() {
    if (this.storySource) this.storySource.cancel('stories');
  }

  static async getCarouselData(url) {
    this.carouselSourse = axios.CancelToken.source();
    const cacheType = url === 'news_coverages' ? cachingHigh : cachingVeryHigh;

    if (caches[url] && caches[url].expDate > Date.now()) {
      return caches[url].response;
    }

    try {
      const res = await RetryAPICall(APIWithoutToken, url, {
        cancelToken: this.carouselSourse.token,
        headers: {
          'Cache-control': returnAPICachingHeader(cacheType),
        },
      });

      caches[url] = {
        expDate: getAPICachingTime(cacheType),
        response: res.data[url],
      };

      return res.data[url];
    } catch (e) {
      if (axios.isCancel(e)) {
        console.log('Request canceled', e.message);
        return null;
      }
      console.error(e.message);
    }
  }

  static cancelCarouselRequest() {
    if (this.carouselSourse) this.carouselSourse.cancel('carousel');
  }

  static async isWatchListPresent() {
    try {
      const { data } = await RetryAPICall(API, '/watchlists/total_count');
      return data.watchlists_count > 0;
    } catch (e) {
      if (axios.isCancel(e)) {
        console.log('Request canceled', e.message);
        return null;
      }
      console.error(e.message);
    }
  }
}
